// @flow
// @flow-runtime warn
import type { Request } from '../../../../index';


export type ComplexesFreeParams = {
  date: string,
  customer_id: number,
  complex_guid: string,
  purchase_guid?: string
}

export type ComplexesFreeResult = boolean;

export const GET_CAFETERIA_CUSTOMER_MENU_COMPLEXES_FREE: Request<ComplexesFreeParams, ComplexesFreeResult> = [
  'cafeteria/customer/menu/complexes/free',
  'get',
  ['data', 'free'],
];
